import React, { ReactNode } from 'react';

export const LinkEmail = ({label,email,className,children,icon}:{label:string,email:string,className?:string,children?:ReactNode,icon?:ReactNode}) => {
  return <a href={`mailto:${email}`} className={className}>{children ?? label}{icon}</a>
};